import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    FormControl,
    Select,
    MenuItem,
    TextField
} from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { errorAlert, successAlert } from 'ui-component/Toasts';
import { axiosInstance } from 'utils/axios';
import { selectCurrentToken } from 'features/auth/authSlice';

const UpdateEarnWalletWithdrawalModal = ({ row, fetchEarnWalletWithdrawalRecord, status }) => {
    const token = useSelector(selectCurrentToken);

    const [open, setOpen] = useState(false);

    const [loading, setLoading] = useState(false);
    const [amount, setAmount] = useState(row.amount);
    const [newStatusID, setNewStatusID] = useState(row.statusID);

    const updateAmbassadorDeposit = async () => {
        setLoading(true);

        try {
            const res = await axiosInstance.put(
                `/EarnWalletWithdrawal`,
                {
                    id: row.id,
                    amount: parseFloat(amount),
                    statusID: newStatusID
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (res.status === 200) {
                successAlert('Success!');
                fetchEarnWalletWithdrawalRecord();
                setOpen(false);
            } else {
                errorAlert('Something went wrong.');
            }
        } catch (error) {
            errorAlert('Something went wrong.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Button variant="outlined" onClick={() => setOpen(true)} fullWidth>
                Update
            </Button>
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="md">
                <DialogTitle fontSize={16}>{'Update Earn Wallet Withdrawal'}</DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', gap: '3px', flexDirection: 'column', marginBottom: '20px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Amount :
                        </Typography>
                        <FormControl fullWidth>
                            <TextField variant="outlined" value={amount} onChange={(e) => setAmount(e.target.value)} />
                        </FormControl>
                    </Box>
                    <Box sx={{ display: 'flex', gap: '3px', flexDirection: 'column', marginBottom: '20px' }}>
                        <Typography
                            sx={{
                                fontSize: '16px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            Status :
                        </Typography>
                        <FormControl fullWidth>
                            <Select value={newStatusID} onChange={(e) => setNewStatusID(e.target.value)} sx={{ minWidth: '200px' }}>
                                {status.map((s) => {
                                    return (
                                        <MenuItem key={s.id} value={s.id}>
                                            {s.name}
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="error" onClick={() => setOpen(false)} disabled={loading}>
                        Cancel
                    </Button>
                    <Button color="secondary" onClick={() => updateAmbassadorDeposit()} disabled={loading}>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default UpdateEarnWalletWithdrawalModal;
